// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eventNode--2wuQuvET {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n}\n\n.rootNode--3d72Xljy {\n  background: #bae7ff;\n}\n\n.handlerTitle--3TunIbgf,\n.handlerContent--GscrkHju,\n.divider--KLrdHe3I {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.divider--KLrdHe3I {\n  color: var(--antd-text-color-secondary);\n}\n\n.items--4bgrktnt {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.upstreamSource--1fS3O0CQ {\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eventNode": "eventNode--2wuQuvET",
	"rootNode": "rootNode--3d72Xljy",
	"handlerTitle": "handlerTitle--3TunIbgf",
	"handlerContent": "handlerContent--GscrkHju",
	"divider": "divider--KLrdHe3I",
	"items": "items--4bgrktnt",
	"upstreamSource": "upstreamSource--1fS3O0CQ"
};
export default ___CSS_LOADER_EXPORT___;
